import { useState, useEffect } from 'react'

import DonationGoal from '../auctions/DonationGoal'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/auctions.module.scss'
import cardCss from '../items/sass/itemcard.module.scss'
import DonationGoalButton from './DonationGoalButton'

export default function DonationButton({ auction, userAttending, auctionState, auctionUser, setShowDonationModal }) {

  const [userDonationTotal, setUserDonationTotal] = useState(0)
  const [showDonationCard, setShowDonationCard] = useState(false)

  useEffect(() => {
    const myAuctions = auctionUser?.MyAuctions
    const currentAuction = myAuctions?.find(a => a.AuctionId === auction.AuctionId)
    setUserDonationTotal(currentAuction?.DonationTotal || 0)

  }, [auctionUser])

  //should we see the donation card?
  useEffect(() => {

    //return early if criteria met

    //if auction does not have donation
    if (auction.HasDonation !== true) {
      setShowDonationCard(false)
      return
    }
    // if user is not attending
    else if (!userAttending) {
      setShowDonationCard(false)
      return
    }
    // if auction has not started
    else if (auctionState === 'before') {
      setShowDonationCard(false)
      return
    }
    //if auction has ended and user did not donate
    else if (auctionState === 'ended' && userDonationTotal === 0) {
      setShowDonationCard(false)
      return
    } else {
      setShowDonationCard(true)
    }

  }, [userAttending, auctionState, auction.HasDonation, auctionUser, userDonationTotal])

  //if there is no donation, no fixed items, and no categories, don't show filter
  if (!showDonationCard) return <></>

  // if there is a donation goal, show the donation goal div with button to donate instead
  if (auction?.IncludeFundraisingGoal === true) return <DonationGoalButton  auction={auction} userAttending={userAttending} 
    auctionState={auctionState} auctionUser={auctionUser} setShowDonationModal={setShowDonationModal} />

  return (
    <div>
      {/* could we maybe instead make the button text say make donation when no donation, but after they donate make it say "Add to $__ donation"???? */}
      {auctionState === 'started' && 
        <button className={`${themeCss['FilledYellow']} ${themeCss['button']} ${cardCss['place-bid-button']}`} 
        disabled={userDonationTotal > 9999} onClick={() => setShowDonationModal(true)}>
        Make Donation</button>}
        {/* {(userDonationTotal > 9999 && (auctionState === 'started')) && <p className={css['donation-max']}>
            You have reached the maximum donation threshold, if you would like to donate more, please contact the auction administrator.
          </p>} */}
      
    </div>
  )
}
